"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var idm_report_export_service_client_js_1 = require("@synisys/idm-report-export-service-client-js");
var StyleConverter = /** @class */ (function () {
    function StyleConverter() {
    }
    StyleConverter.covert = function (textStyleDto) {
        var styles = {};
        if (!textStyleDto) {
            return styles;
        }
        if (textStyleDto.fontSize) {
            styles['font-size'] = textStyleDto.fontSize + "px";
        }
        if (textStyleDto.backgroundColor) {
            styles['background-color'] = textStyleDto.backgroundColor;
        }
        if (textStyleDto.fontName) {
            styles['font-family'] = StyleConverter.getFontName(textStyleDto.fontName);
        }
        if (textStyleDto.color) {
            styles['color'] = textStyleDto.color;
        }
        if (textStyleDto.width !== undefined && textStyleDto.width !== null) {
            styles['width'] = textStyleDto.width + "px";
        }
        if (textStyleDto.align !== undefined && textStyleDto.align !== null) {
            switch (textStyleDto.align) {
                case 0:
                    styles['text-align'] = "left";
                    break;
                case 1:
                    styles['text-align'] = "center";
                    break;
                case 2:
                    styles['text-align'] = "right";
                    break;
            }
        }
        if (textStyleDto.isBold) {
            styles['font-weight'] = 'bold';
        }
        if (textStyleDto.isItalic) {
            styles['font-style'] = 'italic';
        }
        if (textStyleDto.isUnderline) {
            styles['text-decoration'] = 'underline';
        }
        return styles;
    };
    StyleConverter.getFontName = function (fontName) {
        switch (fontName) {
            case idm_report_export_service_client_js_1.FontName.ROBOTO:
                return 'Roboto, sans-serif';
            case idm_report_export_service_client_js_1.FontName.ARIAL:
                return 'Arial, sans-serif';
            case idm_report_export_service_client_js_1.FontName.TAHOMA:
                return 'Tahoma, Geneva, sans-serif';
            case idm_report_export_service_client_js_1.FontName.VERDANA:
                return 'Verdana, Geneva, sans-serif';
            case idm_report_export_service_client_js_1.FontName.HELVETICA:
                return '"Helvetica Neue", Helvetica, sans-serif';
            case idm_report_export_service_client_js_1.FontName.GEORGIA:
                return 'Georgia, serif';
            case idm_report_export_service_client_js_1.FontName.TIMES_NEW_ROMAN:
                return '"Times New Roman", Times, serif';
            case idm_report_export_service_client_js_1.FontName.PALATINO:
                return '"Palatino Linotype", "Book Antiqua", Palatino, serif';
            case idm_report_export_service_client_js_1.FontName.COURIER:
                return '"Courier New", Courier, monospace';
            case idm_report_export_service_client_js_1.FontName.MONACO:
                return 'Monaco, monospace';
        }
    };
    return StyleConverter;
}());
exports.StyleConverter = StyleConverter;
//# sourceMappingURL=style-converter.js.map